import { useContext, useEffect, useState } from "react";
import { tableData } from "./tableData";
import { Container, ContainerScreenGeneral, MuniSpinner2, ScreenHeader, Table } from "../../components";
import { useActasStore } from "../../store/actasStore";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";
import { useActaDetalleStore } from "../../store/actaDetalleStore";
import ModalsOpcionesActas from "../../views/modals";
import { useNotificadores } from "../../hooks/useNotificadores";
import HeaderActas from "./components/HeaderActas";
import { useFilterActas } from "../../store/filterActasStore";
import { getActasHandler } from "../../handlers/actas.handler";
import { createWatchedObject } from "../../utils/watchObject";
import { Button, Form } from "react-bootstrap";
import ModalRangoFecha from "../../views/modals/ModalRangoFecha";
import ModalImprimirActas from "../../views/modals/ModalImprimirActas";
import ModalAsignarActas from "../../views/modals/ModalAsignarActas";
import ModalNotificadoresTable from "../../views/modals/ModalNotificadoresTable";
import ModalDesasignarActa from "../../views/modals/ModalDesasignarActa";
import useActas from "../../api/actas";
import FilterEstados from "./components/FilterEstados/FilterEstados";
import { UserContext } from "../../context";
import { tableInfo } from "./tableInfo";
// import { controlShowActaDetalle } from "../../services/detalleActa.service";
import { controlShowActaDetalleHandler } from "../../handlers/actaDetalle.handler";
import { SearchIcon } from "../../components/Icons";

const GestionActas = ({ titulo, pathActas, estado_id, estados }) => {


    //* NUEVOO
    const { actions } = useContext(UserContext);
    const [estado, setEstado] = useState(actions.hasRole('tribunales') ? 4 : 3);



    //TODO ESTADOS GLOBALES
    //TODO  ------------------------------------------------------------------------------------------
    const { loads, modals, handlerModal } = useGeneralAppStore();
    const { actas, actasFilter, setActasFilter, codigosZonales, codigosForaneos, setActaAImprimir, actaAImprimir, setActas, cleanActas } = useActasStore();
    const { cleanStore, actaDetalle, coleccionActasDetalle, setAllActaDetalle, } = useActaDetalleStore();
    const { filterFields, orderBy, paginateCfg } = useFilterActas();
    const {
        getActaChequear,
        getActaDetalle,
        quitarNotificadorAsignado,
        buscarActa
    } = useActas();

    //^ ESTADOS LOCALES
    //^  ------------------------------------------------------------------------------------------
    const [order, setOrder] = useState("asc");
    const [orderField, setOrderField] = useState("fecha_hora");
    const [filtersFileds, setFiltersField] = useState({ fecha_hora: "", });
    const [actasAImprimir, setActasAImprimir] = useState([]);
    const [notificador, setNotificador] = useState();
    const [actasAsignar, setActasAsignar] = useState([]);
    const [actaADesasignar, setActaADesasignar] = useState();
    const [refetch, setRefetch] = useState()
    const [actasLocale, setActasLocale] = useState();
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 100 });
    const [isFilterChange, setIsFilterChange] = useState(false);
    const [enterScreen, setEnterScreen] = useState(true);

    const [activeImprimir, setActiveImprimir] = useState(false);
    const [activeAsignar, setActiveAsignar] = useState(false);


    //~ HOOKS
    //~  ------------------------------------------------------------------------------------------
    const { getNotificadores } = useNotificadores()
    const { setFilterFields, returnResetFilterFields } = useFilterActas()

    //& KEYS
    //& -----------------------------------------------------------------------------------------
    const loadKeys = [
        "asignar_notificador",
        "acta_detalle",
        "desasignar_notificador",
        "marcar_impresa",
        // "actas",
        'control_acta',
        "notificadores",
        // "get_actas"
    ];

    const handlePaginationChange = (model) => {
        setPaginationModel(model);
    };

    // useEffect(() => {
    //     if (estado_id == 2) {
    //         getNotificadores()
    //     }
    //     return () => {
    //         cleanStore();
    //         cleanActas();
    //     };
    // }, [estado_id]);

    useEffect(() => {
        if (isFilterChange || paginationModel || orderBy || estado) {
            const timer = setTimeout(() => {
                getActasHandler(
                    setActasLocale,
                    isFilterChange ? { page: 0, pageSize: 100 } : paginationModel,
                    {
                        filtros: isFilterChange
                            ? filterFields
                            : [3, 7, 10, 2, 13, 15, 12].includes(estado)
                                ? { ...filterFields, notificador: "" }
                                : filterFields,
                        estado_id: [estado],
                        order: orderBy,
                        per_page: paginationModel.pageSize
                    }
                );
                // setIsFilterChange(false);
                setRefetch(false);
                setEnterScreen(false)
            }, 750);
            return () => clearTimeout(timer);
        }
    }, [filterFields, paginationModel, orderBy, estado]);

    // useEffect(() => {
    //     if (!enterScreen) {
    //         if (estado) {
    //             getActasHandler(
    //                 setActasLocale,
    //                 isFilterChange ? { page: 0, pageSize: 100 } : paginationModel,
    //                 {
    //                     filtros: isFilterChange
    //                         ? filterFields
    //                         : [3, 7, 10, 2, 13, 15, 12].includes(estado)
    //                             ? { ...filterFields, notificador: "" }
    //                             : filterFields,
    //                     estado_id: [estado],
    //                     order: orderBy,
    //                     per_page: paginationModel.pageSize
    //                 }
    //             );
    //             setRefetch(false);
    //         }
    //     }
    // }, [estado]);

    useEffect(() => {
        if (refetch) {
            // const timer = setTimeout(() => {
            getActasHandler(
                setActasLocale,
                isFilterChange ? { page: 0, pageSize: 100 } : paginationModel,
                {
                    filtros: isFilterChange
                        ? filterFields
                        : [3, 7, 10, 2, 13, 15, 12].includes(estado)
                            ? { ...filterFields, notificador: "" }
                            : filterFields,
                    estado_id: [estado],
                    order: orderBy,
                    per_page: paginationModel.pageSize
                }
            );
            // setIsFilterChange(false);
            setRefetch(false);
            // }, 750);
            // return () => clearTimeout(timer);
        }
    }, [refetch == true]);

    // useEffect(() => {
    //     if (filterFields && filterFields !== null) {
    //         setIsFilterChange(true);
    //         setPaginationModel({ page: 0, pageSize: 100 }); 
    //         const timer = setTimeout(() => {
    //             getActasHandler(
    //                 setActasLocale,
    //                 { page: 0, pageSize: 100 },
    //                 {
    //                     filtros: filterFields,
    //                     estado_id: [estado],
    //                     order: orderBy,
    //                     per_page: paginationModel.pageSize
    //                 }
    //             );
    //         }, 750);
    //         return () => clearTimeout(timer);
    //     }
    // }, [filterFields, estado])

    // useEffect(() => {
    //     if (refetch == true) {
    //         getActasHandler(
    //             setActasLocale,
    //             { page: 0, pageSize: 100 },
    //             {
    //                 filtros: filterFields,
    //                 estado_id: [estado],
    //                 order: orderBy,
    //                 per_page: paginationModel.pageSize
    //             }
    //         );
    //     }
    //     setRefetch(false)
    // },[refetch])


    // useEffect(() => {
    //     console.log(isFilterChange)
    //     if (!isFilterChange) {
    //         getActasHandler(
    //             setActasLocale,
    //             paginationModel,
    //             {
    //                 filtros: [3, 7, 10, 2, 13, 15, 12].includes(estado) ? { ...filterFields, notificador: "" } : filterFields,
    //                 estado_id: [estado],
    //                 order: orderBy,
    //                 per_page: paginationModel.pageSize
    //             }
    //         );
    //     } else {
    //         setIsFilterChange(false); 
    //     }
    // }, [paginationModel, orderBy, estado]); 

    useEffect(() => {
        return () => {
            returnResetFilterFields();
        }
    }, [])

    const [valorBusqueda, setValorBusqueda] = useState();


    return (
        <>
            <ContainerScreenGeneral titulo={titulo} linkBack={'/'} size={'full'} >
                <div className="position-relative  z-1">

                    {
                        (actions?.hasRole('admin') || actions?.hasRole('admin.app')) &&
                        <form onSubmit={() => buscarActa({ datos_sobre: "estado", valor: valorBusqueda }, '/gestion_actas', setEstado)}>
                            <Form.Group style={{ width: "fit-content" }}>
                                <Form.Label className="m-0">Número acta</Form.Label>
                                <div className="d-flex gap-2">
                                    <Form.Control size="sm" type="number" onChange={(e) => setValorBusqueda(e.target.value)} />
                                    <Button type="submit" size="sm"><SearchIcon width="20" height="20" /></Button>
                                </div>
                            </Form.Group>
                        </form>
                    }
                    {
                        loadKeys.some(key => {
                            if (key == "actas") {
                                return false
                            } else {
                                return loads.includes(key)
                            }
                        }) &&
                        <div className="position-absolute w-100 h-100  d-flex justify-content-center align-items-center z-2" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <FilterEstados estado={estado} setEstado={setEstado} filterFields={filterFields} actasLocale={actasLocale} />


                    <div className="position-relative">
                        <Table
                            className={` ${activeImprimir ? 'border-2 border-primary' : activeAsignar ? 'border-2 border-warning' : 'border-2 border-secondary-subtle '} position-relative`}
                            height={750}
                            maxHeight={'85vh'}
                            columnHeaderHeight={75}
                            bgHeader={estado == 3 ? "#6C757D" : [7, 17, 12, 18].includes(estado) ? '#dc3545' : estado == 10 ? "#0DCAF0" : estado == 10 ? "#1134C9" : [8, 9].includes(estado) ? "#FFC107" : [4, 11].includes(estado) ? "#198754" : [13, 15].includes(estado) ? "#111" : estado == 2 ? "#1134C9" : [19].includes(estado) ? "#7B1FA2" : '#111'}
                            minHeightFooter={"75px"}
                            colorHeader={'#111111'}
                            loading={loads.includes('get_actas') || loads.includes('buscar_acta')}
                            data={tableInfo(actasLocale, setFiltersField, setOrder, setOrderField, estado, setActaAImprimir, setActaADesasignar)}

                            paginationMode="server"
                            paginationModel={paginationModel}
                            onPaginationModelChange={handlePaginationChange}
                            rowCount={paginateCfg?.total || 0}

                            rowClick={(params) => {
                                if ((actions?.hasRole('admin.app') || actions?.hasRole('admin')) && ![1, 4, 11, 13, 14, 15, 19].includes(params?.row?.estado_id)) {
                                    controlShowActaDetalleHandler(params?.row);
                                } else {
                                    if (estado == 3) {
                                        getActaChequear(params?.row?.id);
                                    } else {
                                        getActaDetalle(params?.row?.id);
                                    }
                                }

                            }}
                            renderButtonFooter={() =>
                            (
                                <div className="d-flex gap-5" >
                                    <Form.Group>
                                        <Form.Label className="m-0 w-100 text-center" style={{ fontSize: "0.8rem", cursor: "pointer" }}
                                            htmlFor="domicilio-notificacion"
                                        >
                                            Domicilio electronico
                                        </Form.Label>
                                        <Form.Check
                                            id="domicilio-notificacion"
                                            name="domicilio_notificacion_id"
                                            onChange={(e) => { setFilterFields(e.target.name, e.target.checked); }}
                                        ></Form.Check>
                                    </Form.Group>
                                </div>
                            )}

                            name="actas"
                            // search
                            onCellClick={(a, { target }) => {
                                if (estado_id == 10 && activeImprimir) {
                                    if (a.field === 'actions') {
                                        return
                                    }
                                    // if (actasAImprimir.includes(a.row.id)) {
                                    if (actasAImprimir.find((acta) => acta.id == a.row.id)) {
                                        const newActasAsignadas = actasAImprimir.filter((acta) => acta?.id != a.row.id)
                                        setActasAImprimir(newActasAsignadas);
                                    } else {
                                        setActasAImprimir((prevState) => [...prevState, a.row])
                                    }

                                }
                                if (estado_id == 2 && activeAsignar) {
                                    if (a.field === 'actions') {
                                        return
                                    }
                                    if (!notificador) {
                                        toast.error('Debe serleccionar un notificador para asignarle actas', toastOptions)
                                        return
                                    }
                                    if (actasAsignar.find((acta) => acta.id == a.row.id)) {
                                        const newActasAsignadas = actasAsignar.filter((acta) => acta?.id != a.row.id)
                                        setActasAsignar(newActasAsignadas);
                                    } else {
                                        setActasAsignar((prevState) => [...prevState, a.row])
                                    }
                                }
                            }}


                            getRowClassName={({ row }) => {
                                if (row.bloqueada) {
                                    return 'bloqueada';
                                }

                                // Luego elige según estado_id
                                if (estado_id == 10) {
                                    if (actasAImprimir.find((acta) => acta.id == row.id)) {
                                        return 'imprimir';
                                    } else if (row.dependencia === 'MCD') {
                                        return 'mcd';
                                    }
                                    return '';
                                }

                                if (estado_id == 2) {
                                    if (actasAsignar.find((acta) => acta.id == row.id)) {
                                        return 'asignado';
                                    } else if (row.dependencia === 'MCD') {
                                        return 'mcd';
                                    }
                                    return '';
                                }

                                if (estado_id == 15) {
                                    if (row.baja_tribunal === 1) {
                                        return 'bajaTribunal';
                                    } else if (row.dependencia === 'MCD') {
                                        return 'mcd';
                                    }
                                    return '';
                                }

                                // Por defecto
                                if (row.domicilio_notificacion_id) {
                                    return 'tieneDomicilio';
                                } else if (row.dependencia === 'MCD') {
                                    return 'mcd';
                                }

                                return '';
                            }}

                            sx={{
                                ".MuiDataGrid-row.mcd": {
                                    backgroundColor: '#F4C75B',
                                    color: "#111"
                                },
                                ".MuiDataGrid-row.bloqueada": {
                                    backgroundColor: '#D9B9FF',
                                    color: "#111"
                                },
                                ".MuiDataGrid-row.imprimir": {
                                    backgroundColor: '#5A7DFF',
                                    color: "white"
                                },
                                ".MuiDataGrid-row.asignado": {
                                    backgroundColor: '#FFD54F',
                                    color: "#111"
                                },
                                ".MuiDataGrid-row.bajaTribunal": {
                                    backgroundColor: '#111',
                                    color: "white"
                                },
                                ".MuiDataGrid-row.tieneDomicilio": {
                                    backgroundColor: '#bcd9cf',
                                    color: "#111"
                                },
                                ".MuiDataGrid-row.Mui-hovered": {
                                    backgroundColor: '#D6D6D6',
                                },
                                ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.imprimir": {
                                    backgroundColor: '#1934ad',
                                    color: "white"
                                },
                                ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.tieneDomicilio": {
                                    backgroundColor: '#84AE92',
                                    color: "#111"
                                },
                                ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.bloqueada": {
                                    backgroundColor: '#C1A1E7',
                                    color: "#111"
                                },
                                ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.asignado": {
                                    backgroundColor: '#FFC107',
                                    color: "#111"
                                },
                                ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.mcd": {
                                    backgroundColor: '#D3A93D',
                                    color: "#111"
                                },
                                ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.bajaTribunal": {
                                    backgroundColor: '#202020',
                                    color: "white"
                                },
                            }}
                        />
                        {
                            loads.includes('get_actas') &&
                            <div className="w-100  position-absolute bg-white d-flex justify-content-center align-items-center" style={{ top: "75px", left: 0, zIndex: 999, height: "85%" }}>
                                <MuniSpinner2 />
                            </div>
                        }
                    </div>
                    {/* } */}

                </div>
                {modals.includes("rango_fecha") && <ModalRangoFecha setFiltersField={setFiltersField} />}
                {modals.includes("modal_imprimir_actas") && <ModalImprimirActas setFiltersField={setFiltersField} actasAImprimir={actasAImprimir} setActasAImprimir={setActasAImprimir} setRefetch={setRefetch} />}
                {modals.includes("modal_asignar_actas") && <ModalAsignarActas notificador={notificador} actasAsignar={actasAsignar} setActasAsignar={setActasAsignar} setRefetch={setRefetch} />}
                {modals.includes("notificadores_table") && <ModalNotificadoresTable modals={modals} setNotificador={setNotificador} handlerModal={handlerModal} />}
                {modals.includes("modal_desasignar_acta") && <ModalDesasignarActa modals={modals} actaADesasignar={actaADesasignar} handlerModal={handlerModal} setRefetch={setRefetch} />}

                {actaDetalle &&
                    <ModalsOpcionesActas setRefetch={setRefetch} />
                }

            </ContainerScreenGeneral>
        </>
    );
};
export default GestionActas;
